export enum CompanionInPublicTransportType {
  Monthly = 1,
  Daily,
}
